import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-arrow-icon',
  standalone: true,
  template: `
    <span class="arrow" [class.down]="expanded" aria-hidden="true">
      <svg width="7" height="10" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.750163 7.58341C0.639052 7.58341 0.541829 7.54522 0.458496 7.46883C0.375163 7.39244 0.333496 7.29175 0.333496 7.16675V0.833415C0.333496 0.708415 0.375163 0.60772 0.458496 0.531331C0.541829 0.454942 0.639052 0.416748 0.750163 0.416748C0.777941 0.416748 0.875163 0.458415 1.04183 0.541748L4.06266 3.56258C4.13211 3.63203 4.18072 3.70147 4.2085 3.77091C4.23627 3.84036 4.25016 3.91675 4.25016 4.00008C4.25016 4.08341 4.23627 4.1598 4.2085 4.22925C4.18072 4.29869 4.13211 4.36814 4.06266 4.43758L1.04183 7.45841C1.00016 7.50008 0.955024 7.53133 0.906413 7.55216C0.857802 7.573 0.805718 7.58341 0.750163 7.58341Z"
          fill="currentColor"
        />
      </svg>
    </span>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        line-height: 0; /* remove inline baseline offset */
      }
      .arrow {
        display: inline-flex;
        align-items: center;
        transition: transform 150ms ease;
      }
      svg {
        display: block; /* avoid baseline alignment pushing it up */
      }
      /* default: right */
      .arrow.down {
        transform: rotate(90deg);
      } /* rotate to point down */
    `,
  ],
})
export class ArrowIconComponent {
  @Input() expanded: boolean = false;
}
